export interface MockAppointment {
  id: number;
  applicant_id: number;
  application_id?: number;
  center_id: number;
  center_name: string;
  test_type: string;
  appointment_date: string;
  time_slot: string;
  status: 'SCHEDULED' | 'COMPLETED' | 'CANCELLED' | 'NO_SHOW';
  booking_reference: string;
  notes?: string;
  created_at: string;
  updated_at: string;
}

export const mockAppointments: MockAppointment[] = [
  {
    id: 1,
    applicant_id: 1,
    application_id: 1,
    center_id: 1,
    center_name: 'Lagos Testing Center - Ikeja',
    test_type: 'Written Exam - Private Pilot License',
    appointment_date: '2025-01-15',
    time_slot: '10:00 - 11:00',
    status: 'SCHEDULED',
    booking_reference: 'BK-20250109-A1B2C3D4',
    notes: 'Bring original ID and application confirmation',
    created_at: '2025-01-02T10:30:00Z',
    updated_at: '2025-01-02T10:30:00Z',
  },
  {
    id: 2,
    applicant_id: 2,
    application_id: 2,
    center_id: 2,
    center_name: 'Abuja Testing Center - Garki',
    test_type: 'Medical Examination',
    appointment_date: '2025-01-18',
    time_slot: '14:00 - 15:00',
    status: 'SCHEDULED',
    booking_reference: 'BK-20250110-E5F6G7H8',
    created_at: '2025-01-03T14:15:00Z',
    updated_at: '2025-01-03T14:15:00Z',
  },
  {
    id: 3,
    applicant_id: 1,
    application_id: 1,
    center_id: 1,
    center_name: 'Lagos Testing Center - Ikeja',
    test_type: 'Flight Test - PPL',
    appointment_date: '2024-12-20',
    time_slot: '10:00 - 11:00',
    status: 'COMPLETED',
    booking_reference: 'BK-20241220-I9J0K1L2',
    notes: 'Passed with score 85/100',
    created_at: '2024-12-15T09:00:00Z',
    updated_at: '2024-12-20T11:00:00Z',
  },
  {
    id: 4,
    applicant_id: 3,
    application_id: 3,
    center_id: 3,
    center_name: 'Port Harcourt Testing Center',
    test_type: 'Written Exam - Commercial Pilot',
    appointment_date: '2025-01-12',
    time_slot: '09:00 - 10:00',
    status: 'CANCELLED',
    booking_reference: 'BK-20250105-M3N4O5P6',
    notes: 'Cancelled by applicant due to scheduling conflict',
    created_at: '2024-12-28T16:20:00Z',
    updated_at: '2025-01-04T08:30:00Z',
  },
  {
    id: 5,
    applicant_id: 4,
    application_id: 4,
    center_id: 4,
    center_name: 'Kano Testing Center',
    test_type: 'Medical Examination',
    appointment_date: '2025-01-20',
    time_slot: '11:00 - 12:00',
    status: 'SCHEDULED',
    booking_reference: 'BK-20250111-Q7R8S9T0',
    created_at: '2025-01-05T11:45:00Z',
    updated_at: '2025-01-05T11:45:00Z',
  },
  {
    id: 6,
    applicant_id: 2,
    application_id: 2,
    center_id: 2,
    center_name: 'Abuja Testing Center - Garki',
    test_type: 'Written Exam - Instrument Rating',
    appointment_date: '2024-12-18',
    time_slot: '13:00 - 14:00',
    status: 'COMPLETED',
    booking_reference: 'BK-20241215-X1Y2Z3A4',
    notes: 'Passed successfully',
    created_at: '2024-12-10T08:20:00Z',
    updated_at: '2024-12-18T15:00:00Z',
  },
  {
    id: 7,
    applicant_id: 1,
    center_id: 1,
    center_name: 'Lagos Testing Center - Ikeja',
    test_type: 'Biometric Capture',
    appointment_date: '2025-01-08',
    time_slot: '15:00 - 15:30',
    status: 'COMPLETED',
    booking_reference: 'BK-20250105-B5C6D7E8',
    created_at: '2025-01-04T09:00:00Z',
    updated_at: '2025-01-08T16:00:00Z',
  },
  {
    id: 8,
    applicant_id: 3,
    application_id: 5,
    center_id: 5,
    center_name: 'Lagos Testing Center - Victoria Island',
    test_type: 'Document Verification',
    appointment_date: '2025-01-22',
    time_slot: '10:30 - 11:30',
    status: 'SCHEDULED',
    booking_reference: 'BK-20250112-F9G0H1I2',
    notes: 'Bring all original documents for verification',
    created_at: '2025-01-06T13:25:00Z',
    updated_at: '2025-01-06T13:25:00Z',
  },
];

// Helper to get appointments for a specific applicant
export const getApplicantAppointments = (applicantId: number): MockAppointment[] => {
  return mockAppointments.filter((apt) => apt.applicant_id === applicantId);
};

// Helper to get appointments for a specific application
export const getApplicationAppointments = (applicationId: number): MockAppointment[] => {
  return mockAppointments.filter((apt) => apt.application_id === applicationId);
};

// Helper to get upcoming appointments
export const getUpcomingAppointments = (applicantId?: number): MockAppointment[] => {
  const today = new Date().toISOString().split('T')[0];
  let filtered = mockAppointments.filter(
    (apt) => apt.appointment_date >= today && apt.status === 'SCHEDULED'
  );

  if (applicantId) {
    filtered = filtered.filter((apt) => apt.applicant_id === applicantId);
  }

  return filtered.sort((a, b) => a.appointment_date.localeCompare(b.appointment_date));
};
